(() => {
  const SELECTOR = '[data-byzayn-tote-personalization]';
  const ATTRIBUTE_NAME = 'ByZayn personalized tote name';
  const timers = new WeakMap();

  const getScope = (block) => block.closest('.cart-summary, .cart-drawer__summary, form') || block.parentElement;

  const controls = (block) => {
    const scope = getScope(block);
    return {
      buttons: [...scope.querySelectorAll('button[name="checkout"], input[name="checkout"]')],
      accelerated: [...scope.querySelectorAll('.additional-checkout-buttons')]
    };
  };

  const setCheckoutBlocked = (block, blocked) => {
    const found = controls(block);
    found.buttons.forEach((button) => {
      button.disabled = blocked;
      button.setAttribute('aria-disabled', String(blocked));
      button.toggleAttribute('data-byzayn-tote-blocked', blocked);
    });
    found.accelerated.forEach((container) => {
      container.inert = blocked;
      container.setAttribute('aria-disabled', String(blocked));
      container.toggleAttribute('data-byzayn-tote-blocked', blocked);
    });
  };

  const setStatus = (block, state, message) => {
    block.dataset.state = state;
    const status = block.querySelector('[data-byzayn-tote-status]');
    if (status) status.textContent = message;
  };

  const syncFields = (value) => {
    document.querySelectorAll('[data-byzayn-tote-name]').forEach((field) => {
      if (field.value !== value) field.value = value;
    });
  };

  const saveName = async (block, input) => {
    const value = input.value.trim();
    setCheckoutBlocked(block, true);
    setStatus(block, 'saving', value ? 'Saving your tote name…' : 'Removing the saved name…');

    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(root + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes: { [ATTRIBUTE_NAME]: value } })
      });
      if (!response.ok) throw new Error('Cart update failed');

      syncFields(value);
      document.querySelectorAll(SELECTOR).forEach((currentBlock) => {
        setCheckoutBlocked(currentBlock, !value);
        setStatus(currentBlock, value ? 'saved' : 'required', value ? 'Name saved to your cart.' : 'Enter a name to continue to checkout.');
      });
    } catch (_) {
      setCheckoutBlocked(block, true);
      setStatus(block, 'error', 'We could not save the name. Please try again or email hello@byzaynco.com.');
    }
  };

  const bind = (block) => {
    const input = block.querySelector('[data-byzayn-tote-name]');
    if (!input || input.dataset.bound === 'true') return;
    input.dataset.bound = 'true';
    const initial = input.value.trim();
    setCheckoutBlocked(block, !initial);
    setStatus(block, initial ? 'saved' : 'required', initial ? 'Name saved to your cart.' : 'Enter a name to continue to checkout.');

    input.addEventListener('input', () => {
      const value = input.value.trim();
      setCheckoutBlocked(block, true);
      setStatus(block, value ? 'pending' : 'required', value ? 'Saving your tote name…' : 'Enter a name to continue to checkout.');
      clearTimeout(timers.get(input));
      timers.set(input, setTimeout(() => saveName(block, input), 500));
    });

    input.addEventListener('blur', () => {
      clearTimeout(timers.get(input));
      saveName(block, input);
    });
  };

  const bindAll = () => document.querySelectorAll(SELECTOR).forEach(bind);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bindAll, { once: true });
  else bindAll();
  new MutationObserver(bindAll).observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('shopify:section:load', bindAll);
  document.addEventListener('cart:updated', bindAll);
})();